import type {PerkIntegrationConfigComponentProps} from '@cohort/merchants/apps';
import LocalizedUrlInput from '@cohort/merchants/components/form/input/LocalizedUrlInput';
import {useCurrentMerchant} from '@cohort/merchants/hooks/contexts/currentMerchant';
import {useCohortForm} from '@cohort/merchants/hooks/contexts/form';
import type {PerkFormValues} from '@cohort/merchants/pages/perks/perk/edit/utils';
import {useWatch} from 'react-hook-form';
import {useTranslation} from 'react-i18next';

const CohortLinkPerkIntegrationConfigComponent: React.FC<
  PerkIntegrationConfigComponentProps
> = () => {
  const merchant = useCurrentMerchant();
  const {register, control} = useCohortForm<PerkFormValues>();

  const selectedLanguage = useWatch({
    control,
    name: 'selectedLanguage',
  });
  const {t} = useTranslation('app-cohort', {
    keyPrefix: 'perkIntegrations.link.configComponent',
  });
  const isDefaultLanguageSelected = selectedLanguage === merchant.defaultLanguage;

  return (
    <div className="space-y-6">
      <LocalizedUrlInput
        name="integration.config.url"
        label={t('labelUrl')}
        register={register}
        control={control}
        selectedLanguage={selectedLanguage}
        optional={!isDefaultLanguageSelected}
      />
    </div>
  );
};

export default CohortLinkPerkIntegrationConfigComponent;
